import { render, staticRenderFns } from "./IconVloeren.vue?vue&type=template&id=70a04132"
import script from "./IconVloeren.vue?vue&type=script&lang=ts"
export * from "./IconVloeren.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports